(function () {
  'use strict';

  var root = document.querySelector('.lao');
  if (!root) return;

  var LANG_KEY = 'bho-language';
  var PLANNER_KEY = 'la_ownerhub_v6_planner';
  var PACKAGE_KEY = 'la_ownerhub_v6_package';
  var lang = localStorage.getItem(LANG_KEY) === 'en' ? 'en' : 'zh';
  var selectedPackage = localStorage.getItem(PACKAGE_KEY) || '1';

  var packages = {
    '1': {
      variant: '48321241284761',
      label: { zh: '1套 · S$92', en: '1 Set · S$92' },
      button: { zh: '加入购物车 — 1套 S$92', en: 'Add to Cart — 1 Set S$92' },
      message: { zh: '您好，我想订购1套雄液补品，价格S$92。请协助我安排订单。', en: 'Hello, I would like to order 1 set of LA Tonic at S$92. Please help me arrange the order.' }
    },
    '3': {
      variant: '48321240826009',
      label: { zh: '3套 · S$246', en: '3 Sets · S$246' },
      button: { zh: '加入购物车 — 3套 S$246', en: 'Add to Cart — 3 Sets S$246' },
      message: { zh: '您好，我想订购3套雄液补品，价格S$246（每套S$82）。请协助我安排订单。', en: 'Hello, I would like to order 3 sets of LA Tonic at S$246 (S$82 per set). Please help me arrange the order.' }
    },
    '6': {
      variant: '48967600242841',
      label: { zh: '6套 · S$468', en: '6 Sets · S$468' },
      button: { zh: '加入购物车 — 6套 S$468', en: 'Add to Cart — 6 Sets S$468' },
      message: { zh: '您好，我想订购6套雄液补品，价格S$468（每套S$78）。请协助我安排订单。', en: 'Hello, I would like to order 6 sets of LA Tonic at S$468 (S$78 per set). Please help me arrange the order.' }
    }
  };

  function track(eventName, detail) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName, page: 'la_ownerhub_v6' }, detail || {}));
  }

  function updateWhatsAppLinks() {
    document.querySelectorAll('[data-whatsapp-message]').forEach(function (link) {
      var message = lang === 'en' ? link.dataset.whatsappEn : link.dataset.whatsappZh;
      link.href = 'https://wa.me/6588269998?text=' + encodeURIComponent(message || '');
    });
  }

  function setLanguage(next, shouldTrack) {
    lang = next === 'en' ? 'en' : 'zh';
    root.dataset.language = lang;
    document.body.dataset.language = lang;
    var globalHeader = document.querySelector('.bho-global-header');
    if (globalHeader) globalHeader.dataset.language = lang;
    document.documentElement.lang = lang === 'en' ? 'en-SG' : 'zh-SG';
    document.querySelectorAll('[data-set-lang]').forEach(function (button) {
      button.setAttribute('aria-pressed', String(button.dataset.setLang === lang));
    });
    document.querySelectorAll('[data-bho-global-language]').forEach(function (button) {
      button.setAttribute('aria-pressed', String(button.dataset.bhoGlobalLanguage === lang));
    });
    document.querySelectorAll('option[data-zh-option]').forEach(function (option) {
      option.textContent = lang === 'en' ? option.dataset.enOption : option.dataset.zhOption;
    });
    root.querySelectorAll('[data-aria-zh]').forEach(function (element) {
      element.setAttribute('aria-label', lang === 'en' ? element.dataset.ariaEn : element.dataset.ariaZh);
    });
    root.querySelectorAll('[data-alt-zh]').forEach(function (element) {
      element.alt = lang === 'en' ? element.dataset.altEn : element.dataset.altZh;
    });
    localStorage.setItem(LANG_KEY, lang);
    updateWhatsAppLinks();
    updatePackageDisplay();
    updatePlanner();
    if (shouldTrack) track('ownerhub_language_change', { language: lang });
  }

  document.querySelectorAll('[data-set-lang]').forEach(function (button) {
    button.addEventListener('click', function () { setLanguage(button.dataset.setLang, true); });
  });
  document.querySelectorAll('[data-bho-global-language]').forEach(function (button) {
    button.addEventListener('click', function () {
      setLanguage(button.dataset.bhoGlobalLanguage, true);
      document.dispatchEvent(new CustomEvent('bho:languagechange', { detail: { language: lang } }));
    });
  });
  document.addEventListener('bho:languagechange', function (event) {
    if (event.detail && event.detail.language) setLanguage(event.detail.language, false);
  });

  function dateFromInput(value) {
    if (!value) return null;
    var parts = value.split('-').map(Number);
    return new Date(parts[0], parts[1] - 1, parts[2], 12);
  }

  function inputFromDate(date) {
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getDate()).padStart(2, '0');
    return year + '-' + month + '-' + day;
  }

  function formatDate(date) {
    return new Intl.DateTimeFormat(lang === 'en' ? 'en-SG' : 'zh-SG', { day: 'numeric', month: 'long', year: 'numeric' }).format(date);
  }

  function addDays(date, days) {
    var copy = new Date(date.getTime());
    copy.setDate(copy.getDate() + days);
    return copy;
  }

  var planner = document.querySelector('[data-planner]');
  var contactDate = document.querySelector('[data-contact-date]');
  var finishDate = document.querySelector('[data-finish-date]');
  var calendarButton = document.querySelector('[data-calendar]');
  var calculatedContactDate = null;
  var plannerNotice = document.querySelector('[data-planner-notice]');

  function updatePlanner() {
    if (!planner || !contactDate || !finishDate) return;
    var start = dateFromInput(planner.querySelector('[name="start"]').value);
    var sets = Math.max(1, Number(planner.querySelector('[name="sets"]').value) || 1);
    var routine = planner.querySelector('[name="routine"]').value;
    var servingInterval = routine === 'maintenance' ? 2 : 1;
    if (plannerNotice) { plannerNotice.hidden = true; plannerNotice.textContent = ""; }
    if (!start || isNaN(start.getTime())) {
      contactDate.textContent = '—';
      finishDate.textContent = '—';
      calculatedContactDate = null;
      if (calendarButton) calendarButton.disabled = true;
      return;
    }
    var finish = addDays(start, ((sets * 15) - 1) * servingInterval);
    calculatedContactDate = addDays(finish, -5);
    contactDate.textContent = formatDate(calculatedContactDate);
    finishDate.textContent = formatDate(finish);
    var today = dateFromInput(inputFromDate(new Date()));
    var reorderPassed = calculatedContactDate < today;
    var finishPassed = finish < today;
    var reorderToday = calculatedContactDate.getTime() === today.getTime();
    if (calendarButton) calendarButton.disabled = reorderPassed;
    if (plannerNotice && (reorderPassed || reorderToday)) {
      plannerNotice.hidden = false;
      plannerNotice.textContent = finishPassed
        ? (lang === 'en' ? 'Your estimated finish date has passed. Check your remaining supply and update the start date or set count, or reorder below.' : '预计用完日期已过。请检查剩余用量，并更新开始日期或套数，或查看下方配套补购。')
        : reorderPassed
          ? (lang === 'en' ? 'Your suggested reorder date has passed. Check your remaining supply and reorder if needed. Update the inputs if your routine has changed.' : '建议补购日期已过。请检查剩余用量，并按需要安排补购。如服用安排有变，请更新资料。')
          : (lang === 'en' ? 'Today is your suggested reorder date. Check your remaining supply and arrange your next order if needed.' : '今天是建议补购日期。请检查剩余用量，并按需要安排下一次补购。');
    }
    localStorage.setItem(PLANNER_KEY, JSON.stringify({
      start: planner.querySelector('[name="start"]').value,
      sets: String(sets),
      routine: routine
    }));
  }

  if (planner) {
    var savedPlanner = {};
    try { savedPlanner = JSON.parse(localStorage.getItem(PLANNER_KEY) || '{}'); } catch (error) {}
    planner.querySelector('[name="start"]').value = savedPlanner.start || inputFromDate(new Date());
    if (savedPlanner.sets) planner.querySelector('[name="sets"]').value = savedPlanner.sets;
    if (savedPlanner.routine) planner.querySelector('[name="routine"]').value = savedPlanner.routine;
    planner.addEventListener('input', updatePlanner);
    planner.addEventListener('change', function () {
      updatePlanner();
      track('ownerhub_planner_updated', {
        sets: planner.querySelector('[name="sets"]').value,
        routine: planner.querySelector('[name="routine"]').value
      });
    });
  }

  if (calendarButton) {
    calendarButton.addEventListener('click', function () {
      if (!calculatedContactDate || calculatedContactDate < dateFromInput(inputFromDate(new Date()))) return;
      var compactDate = inputFromDate(calculatedContactDate).replace(/-/g, '');
      var compactEndDate = inputFromDate(addDays(calculatedContactDate, 1)).replace(/-/g, '');
      var title = lang === 'en' ? 'Plan my next LA Tonic supply' : '安排下一次雄液补品补购';
      var description = lang === 'en'
        ? 'Review the current LA Tonic packages or contact Best Health on WhatsApp: +65 8826 9998.'
        : '查看目前雄液补品配套，或WhatsApp +65 8826 9998联系Best Health。';
      var ics = [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'PRODID:-//Best Health//LA Owner Hub//EN',
        'BEGIN:VEVENT',
        'DTSTART;VALUE=DATE:' + compactDate,
        'DTEND;VALUE=DATE:' + compactEndDate,
        'SUMMARY:' + title,
        'DESCRIPTION:' + description,
        'END:VEVENT',
        'END:VCALENDAR'
      ].join('\r\n');
      var url = URL.createObjectURL(new Blob([ics], { type: 'text/calendar;charset=utf-8' }));
      var link = document.createElement('a');
      link.href = url;
      link.download = 'la-tonic-reorder-reminder.ics';
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
      track('ownerhub_calendar_download', { reorder_date: inputFromDate(calculatedContactDate) });
    });
  }

  var packageWhatsApp = document.querySelector('[data-package-whatsapp]');
  var orderQuantity = document.querySelector('[data-order-quantity]');
  var orderVariant = document.querySelector('#la-ownerhub-order-form input[name="id"]');
  var orderButton = document.querySelector('[data-order-button]');

  function updatePackageDisplay() {
    if (!packages[selectedPackage]) selectedPackage = '1';
    document.querySelectorAll('[data-package]').forEach(function (button) {
      var active = button.dataset.package === selectedPackage;
      button.classList.toggle('is-selected', active);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-checked', String(active));
    });
    if (orderQuantity) orderQuantity.value = '1';
    if (orderVariant) orderVariant.value = packages[selectedPackage].variant;
    if (orderButton) orderButton.textContent = packages[selectedPackage].button[lang];
    if (packageWhatsApp) packageWhatsApp.href = 'https://wa.me/6588269998?text=' + encodeURIComponent(packages[selectedPackage].message[lang]);
  }

  document.querySelectorAll('[data-package]').forEach(function (button) {
    button.addEventListener('click', function () {
      selectedPackage = button.dataset.package;
      localStorage.setItem(PACKAGE_KEY, selectedPackage);
      updatePackageDisplay();
      track('ownerhub_package_selected', { package_sets: selectedPackage });
    });
  });

  var orderForm = document.querySelector('[data-order-form]') || document.querySelector('#la-ownerhub-order-form');
  var orderStatus = document.querySelector('[data-order-status]');
  if (orderForm) {
    orderForm.addEventListener('submit', function (event) {
      var isLocal = location.protocol === 'file:' || location.hostname === '127.0.0.1' || location.hostname === 'localhost';
      if (!isLocal) return;
      event.preventDefault();
      if (orderStatus) {
        orderStatus.hidden = false;
        orderStatus.textContent = lang === 'en' ? 'Preview only: nothing was added to a cart.' : '本地预览：没有商品加入购物车。';
      }
      track('ownerhub_add_to_cart_preview', { package_sets: selectedPackage });
    });
  }

  var reminderForm = document.querySelector('[data-reminder-form]');
  var reminderStatus = document.querySelector('[data-reminder-status]');
  if (reminderForm) {
    reminderForm.addEventListener('submit', function (event) {
      var isLocal = location.protocol === 'file:' || location.hostname === '127.0.0.1' || location.hostname === 'localhost';
      if (!reminderForm.checkValidity()) return;
      track('ownerhub_email_signup_submit');
      if (isLocal) {
        event.preventDefault();
        if (reminderStatus) {
          reminderStatus.hidden = false;
          reminderStatus.textContent = lang === 'en'
            ? 'Preview only: no email was stored and no discount code was sent.'
            : '本地预览：电邮不会储存，也不会发送优惠码。';
        }
      }
    });
  }

  setLanguage(lang, false);
  updatePackageDisplay();
  updatePlanner();
})();
